export default __webpack_public_path__ + "static/media/1.ee79d129.jpg";